import React from 'react';
import Helmet from 'react-helmet';
import { Layout } from '@storable/canaveral-components';
import { resolveAssetUrl } from '../../../../modules/assets';
import AdminHeader from './AdminHeader';
import styles from './AdminUnauthorized.scss';

const propTypes = {};

const defaultProps = {};

const AdminUnauthorized = () => {
  const header = (
    <AdminHeader />
  );

  const navbar = (
    <Layout.Navbar />
  );

  return (
    <Layout header={header} navbar={navbar}>
      <Helmet title="Unauthorized" />
      <div className={styles.unauthorized}>
        <div className={styles.dialog}>
          <h2>Unauthorized</h2>

          <p>
            You do not have permission to access this page. If you believe this is an
            error, please call us at 913-384-5700.
          </p>
        </div>

        <div className={styles.brandContainer}>
          <a
            target="_blank"
            href="https://www.storedge.com/"
            rel="noopener noreferrer"
          >
            <img
              src={resolveAssetUrl('/img/storable-logo.svg')}
              alt="storEDGE"
              type="image/svg+xml"
            />
          </a>
        </div>
      </div>
    </Layout>
  );
};

AdminUnauthorized.propTypes = propTypes;
AdminUnauthorized.defaultProps = defaultProps;

export default AdminUnauthorized;
